import "babel-polyfill";
import "slick-carousel";

import {binder} from "./libs/binder";
import {constants, detectDevicesAndBrowser} from "./modules/module";
import {showNavigation} from "./modules/show-navigation";
import {showNavDrops} from "./modules/show-navigation-dropdowns";
import {teamSlider} from "./modules/team-slider";
import {scrollAnimate} from "./modules/scroll-animate";
import {initReviewsSlider} from "./modules/reviews-slider";
import {googleMap} from "./modules/googleMap";
import {joinUsSlider} from "./modules/join-us-slider";

binder({
    bounds: {
        "html": [constants, detectDevicesAndBrowser],
        ".burger": showNavigation,
        ".main-menu": showNavDrops,
        ".team-slider": teamSlider,
        ".reviews-section .slider": initReviewsSlider,
        ".scrolled": scrollAnimate,
        "#map": googleMap,
        ".join-us": joinUsSlider,
    },
    runTests: false
});



// WEBPACK FOOTER //
// ./assets/js/global.js